import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, HeartHandshakeIcon, LeafIcon, ScissorsIcon, SparklesIcon, TruckIcon } from 'lucide-react';
import { products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
import { formatPrice } from '../utils/format';
const heroYarn = products.find(p => p.slug === 'comfort-6')!;
const heroDoudou = products.find(p => p.slug === 'ourson-bonnet-mouton')!;
const crochetPieces = products.filter(p => p.category === 'crochet');
const puzzle = products.find(p => p.slug === 'puzzle-personnalise')!;
const laines = products.filter(p => p.category === 'laine');
export function Home() {
  return <>
      <section className="relative overflow-hidden border-b border-encre/10" data-id="element-197" data-mp="2dj1lurj4td7f">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-20" data-id="element-198" data-mp="3kuigzcumsg5s">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-199" data-mp="3oyq9zm84gi9t">
            <p className="font-display text-lg font-semibold text-framboise" data-id="element-200" data-mp="2vvlv8fau044f">La laine, c'est la vie !</p>
            <h1 className="mt-2 font-display text-[44px] font-extrabold leading-[1.02] tracking-tight text-encre sm:text-6xl lg:text-[68px]" data-id="element-201" data-mp="2r0olt79n3sr0">
              Des pelotes qui donnent
              <br data-id="element-202" data-mp="2hz8e57a7m4qh" />
              envie de tout tricoter.
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-encre-soft" data-id="element-203" data-mp="2d65rlj3unvjs">
              Méli Mélo Services, c'est une mercerie de Vouziers : cinq gammes de laine en stock
              permanent, des fils à broder, et des doudous crochetés à la main un par un dans
              l'atelier.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-204" data-mp="1z6weisaxxhk1">
              <Link to="/boutique?cat=laine" className="inline-flex items-center gap-2 rounded-full bg-framboise px-6 py-3.5 font-display text-base font-extrabold text-white transition-colors duration-150 ease-out hover:bg-framboise-dark" data-id="element-205" data-mp="1u82xipwg38f4">
                Choisir mes pelotes
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="1anukxrh8eoid" />
              </Link>
              <Link to="/boutique?cat=crochet" className="inline-flex items-center gap-2 rounded-full border-2 border-encre px-6 py-3.5 font-display text-base font-extrabold text-encre transition-colors duration-150 ease-out hover:bg-encre hover:text-creme" data-id="element-207" data-mp="1fmfc71ei9xuo">
                Les créations faites main
              </Link>
            </div>

            <dl className="mt-10 grid max-w-lg grid-cols-3 gap-6 border-t border-encre/10 pt-6" data-id="element-208" data-mp="1yjgjwtzg2c2b">
              <div data-id="element-209" data-mp="2m9t3j241xx8q">
                <dt className="text-xs font-semibold uppercase tracking-wide text-encre-light" data-id="element-210" data-mp="2m8hxswr1qfez">Coloris</dt>
                <dd className="font-display text-3xl font-extrabold text-encre" data-id="element-211" data-mp="2r2dulvvkpw8k">90+</dd>
              </div>
              <div data-id="element-212" data-mp="fjzivud1omgd">
                <dt className="text-xs font-semibold uppercase tracking-wide text-encre-light" data-id="element-213" data-mp="fjhegag8b1xd">Dès</dt>
                <dd className="font-display text-3xl font-extrabold text-encre" data-id="element-214" data-mp="oe4cumnh6e04">1,90 €</dd>
              </div>
              <div data-id="element-215" data-mp="kcsmgews1oqv">
                <dt className="text-xs font-semibold uppercase tracking-wide text-encre-light" data-id="element-216" data-mp="kcaggqkbbw5r">Atelier</dt>
                <dd className="font-display text-3xl font-extrabold text-encre" data-id="element-217" data-mp="3stdkj0nvexf7">Vouziers</dd>
              </div>
            </dl>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid grid-cols-5 gap-4" data-id="element-218" data-mp="3nvlw4gmfptfr">
            <Link to={`/produit/${heroYarn.slug}`} className="col-span-3 overflow-hidden rounded-4xl bg-white ring-1 ring-encre/10" data-id="element-219" data-mp="1h1i5w9o1ypey">
              <img src={heroYarn.image} alt="Nuancier de la laine Comfort 6" className="h-full w-full object-cover" data-id="element-220" data-mp="27eoiq60qxmrb" />
            </Link>
            <div className="col-span-2 flex flex-col gap-4" data-id="element-221" data-mp="2hbt4w5uldi84">
              <Link to={`/produit/${heroDoudou.slug}`} className="overflow-hidden rounded-4xl bg-white ring-1 ring-encre/10" data-id="element-222" data-mp="2hefc24dklvpt">
                <img src={heroDoudou.image} alt="Ourson crocheté main avec son bonnet mouton" className="h-full w-full object-cover" data-id="element-223" data-mp="2qch805ig5y68" />
              </Link>
              <div className="rounded-4xl bg-encre p-5 text-creme" data-id="element-224" data-mp="304wsb9h7uyua">
                <p className="font-display text-lg font-bold leading-snug" data-id="element-225" data-mp="35140l8x34mfe">
                  Retrait gratuit en boutique
                </p>
                <p className="mt-1.5 text-sm text-creme/70" data-id="element-226" data-mp="3e224zsbfqvyi">
                  58 rue Chanzy, 08400 Vouziers — du mardi au samedi.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section aria-label="Nos engagements" className="border-b border-encre/10 bg-white" data-id="element-227" data-mp="ycbtccakga7x">
        <ul className="mx-auto grid max-w-7xl gap-6 px-4 py-8 sm:grid-cols-2 sm:px-6 lg:grid-cols-4" data-id="element-228" data-mp="tfcy1qf61x85">
          {[{
          icon: LeafIcon,
          title: 'Certifié Oeko-Tex®',
          text: 'Standard 100 sur nos gammes principales'
        }, {
          icon: HeartHandshakeIcon,
          title: 'Fait main',
          text: 'Chaque doudou est crocheté à l\'atelier'
        }, {
          icon: TruckIcon,
          title: 'Livraison offerte',
          text: 'Dès 49 € d\'achat en France'
        }, {
          icon: ScissorsIcon,
          title: 'Conseils mercerie',
          text: 'On vous aide à calculer vos quantités'
        }].map(item => <li key={item.title} className="flex gap-3" data-id="element-229" data-mp="24t71n7wsrc6z">
              <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-framboise" aria-hidden="true" data-id="element-230" data-mp="24urw6xj42v4u" />
              <div data-id="element-231" data-mp="201fihifz08qv">
                <p className="font-display text-base font-bold text-encre" data-id="element-232" data-mp="200xfm2ysyw9z">{item.title}</p>
                <p className="text-sm text-encre-soft" data-id="element-233" data-mp="3ucyg8gi0bwhv">{item.text}</p>
              </div>
            </li>)}
        </ul>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6" data-id="element-234" data-mp="3klklsn4wxmvl">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-235" data-mp="3pjvwt16y23fe">
          <div data-id="element-236" data-mp="3pi16t8gtfl4g">
            <h2 className="font-display text-4xl font-extrabold tracking-tight text-encre" data-id="element-237" data-mp="3phj5hxfaqgpo">
              Nos gammes de laine
            </h2>
            <p className="mt-2 max-w-xl text-encre-soft" data-id="element-238" data-mp="3fmr7ishsxrud">
              Toutes en stock, à la pelote ou au paquet. Cliquez sur une gamme pour voir le
              nuancier complet et commander vos coloris.
            </p>
          </div>
          <Link to="/boutique?cat=laine" className="inline-flex items-center gap-1.5 font-display text-base font-bold text-framboise hover:text-framboise-dark" data-id="element-239" data-mp="36l9rtb8b3s67">
            Toutes les laines <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="14raj8xmkjox7" />
          </Link>
        </div>

        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-241" data-mp="1ev7eu3mxe5jt">
          {laines.map(product => <ProductCard key={product.slug} product={product} data-id="element-242" data-mp="1npvnm3rpm5dd" />)}
        </div>
      </section>

      <section className="bg-framboise-soft" data-id="element-243" data-mp="1izf5w7guvxl7">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:items-center" data-id="element-244" data-mp="1ixlzmta5nfdq">
          <div data-id="element-245" data-mp="1xq5xpfig6wob">
            <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-framboise-dark" data-id="element-246" data-mp="1soyrvlzv87ka">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" data-mp="26ohkt7k3vcc0" /> L'atelier crochet
            </p>
            <h2 className="mt-2 font-display text-4xl font-extrabold leading-tight tracking-tight text-encre" data-id="element-248" data-mp="22nfmqu1xd6bm">
              Des doudous qui prennent
              <br data-id="element-249" data-mp="cb8hxym2ep2q" />
              une dizaine d'heures.
            </h2>
            <p className="mt-4 max-w-md leading-relaxed text-encre-soft" data-id="element-250" data-mp="8a6knnbpkn3e">
              Oursons, éléphants, ballerines : chaque pièce est crochetée à la main, rembourrée
              d'une ouate hypoallergénique, avec des yeux cousus solidement. Certaines sont
              uniques, les autres se font à la commande en huit à dix jours.
            </p>
            <Link to="/boutique?cat=crochet" className="mt-7 inline-flex items-center gap-2 rounded-full bg-encre px-6 py-3.5 font-display text-base font-extrabold text-creme transition-colors duration-150 ease-out hover:bg-encre-soft" data-id="element-251" data-mp="16m8wu22j97mj">
              Découvrir les créations
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="mw5fg1ioqnd5" />
            </Link>
          </div>

          <div className="grid gap-5 sm:grid-cols-3" data-id="element-253" data-mp="rvi2ondgxwg9">
            {crochetPieces.map(piece => <Link key={piece.slug} to={`/produit/${piece.slug}`} className="group overflow-hidden rounded-3xl bg-white ring-1 ring-encre/10" data-id="element-254" data-mp="1ybkdl8mmrl9u">
                <img src={piece.image} alt={piece.name} loading="lazy" className="aspect-[3/4] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-255" data-mp="2dec063v3ywrn" />
                <div className="p-4" data-id="element-256" data-mp="1zmnsqdvt0wh0">
                  <p className="font-display text-base font-bold leading-tight text-encre" data-id="element-257" data-mp="1zlmanpgdf9ps">{piece.name}</p>
                  <p className="mt-1 font-display text-lg font-extrabold text-framboise" data-id="element-258" data-mp="1uodsvpz4x7p2">
                    {formatPrice(piece.price)}
                  </p>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6" data-id="element-259" data-mp="1go32sp5nfx4y">
        <div className="grid items-center gap-8 overflow-hidden rounded-4xl bg-white ring-1 ring-encre/10 lg:grid-cols-2" data-id="element-260" data-mp="1gpwb08vwupf2">
          <img src={puzzle.image} alt="Puzzles personnalisés Meli Melo Services" loading="lazy" className="h-full max-h-[420px] w-full object-cover" data-id="element-261" data-mp="3b1uia5antb8b" />
          <div className="p-8 lg:p-12" data-id="element-262" data-mp="8n9okx1ozoh4">
            <h2 className="font-display text-4xl font-extrabold tracking-tight text-encre" data-id="element-263" data-mp="8m85q6efpxou">
              Puzzles personnalisés
            </h2>
            <p className="mt-3 leading-relaxed text-encre-soft" data-id="element-264" data-mp="hnode6dv7lpd">
              Votre photo imprimée et découpée dans notre atelier, livrée dans sa boîte. Un cadeau
              qui plaît à tous les âges.
            </p>
            <ul className="mt-6 space-y-2" data-id="element-265" data-mp="3l4ws4hdaq5fv">
              {puzzle.options?.map(opt => <li key={opt.id} className="flex items-baseline justify-between border-b border-encre/8 pb-2 text-sm font-semibold text-encre" data-id="element-266" data-mp="3oexz8xhgvmg">
                  <span data-id="element-267" data-mp="37cgmd8t0ftb9">{opt.label}</span>
                  <span className="font-display text-xl font-extrabold text-framboise" data-id="element-268" data-mp="37bf9cysfowqw">
                    {formatPrice(opt.price)}
                  </span>
                </li>)}
            </ul>
            <Link to={`/produit/${puzzle.slug}`} className="mt-7 inline-flex items-center gap-2 rounded-full bg-framboise px-6 py-3.5 font-display text-base font-extrabold text-white transition-colors duration-150 ease-out hover:bg-framboise-dark" data-id="element-269" data-mp="1hujsbdf5sz3x">
              Commander mon puzzle
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-270" data-mp="20mckj5memgal" />
            </Link>
          </div>
        </div>
      </section>
    </>;
}